import api from '../api';

export interface ConfiguracaoFoto {
  id: string;
  tamanhoMinimoKb: number;
  tamanhoMaximoMb: number;
  formatosAceitos: string;
  atualizadoEm: string;
}

export interface ConfiguracaoFotoRequest {
  tamanhoMinimoKb: number;
  tamanhoMaximoMb: number;
  formatosAceitos: string;
}

export default class ConfiguracaoFotoViewModel {
  static async buscar(): Promise<ConfiguracaoFoto | null> {
    const response = await api.get<ConfiguracaoFoto>('/configuracoes/foto', {
      validateStatus: (status) => status === 200 || status === 204,
    });
    if (response.status === 204) {
      return null;
    }
    return response.data;
  }

  static async salvar(payload: ConfiguracaoFotoRequest): Promise<ConfiguracaoFoto> {
    const response = await api.put<ConfiguracaoFoto>('/configuracoes/foto', payload);
    return response.data;
  }
}
